var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.675 5.14307L12.8565 8.32532L5.4315 15.7496H2.25V12.5673L9.675 5.14232V5.14307ZM10.7355 4.08257L12.3263 2.49107C12.4669 2.35047 12.6576 2.27148 12.8565 2.27148C13.0554 2.27148 13.2461 2.35047 13.3868 2.49107L15.5085 4.61282C15.6491 4.75347 15.7281 4.9442 15.7281 5.14307C15.7281 5.34195 15.6491 5.53268 15.5085 5.67332L13.917 7.26407L10.7355 4.08257Z",
    fill: "#E53F50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilFill);
export default __webpack_public_path__ + "static/media/pencil-fill.da67a878192d95081231e7d0987478d9.svg";
export { ForwardRef as ReactComponent };